import React from 'react'
import { Nav, NavItem, NavLink, Badge } from 'reactstrap'



const TopTab = ({ activeTab, toggleTab }) => {
    console.log({ activeTab, toggleTab });
    const myCall = (tab) => {
        if(tab == '1'){
        
          toggleTab('1')
        }
        if(tab == '2'){
          toggleTab('2')
        }
        }


  return (
    <div className='pb-0 p-4'>
      <Nav className='mb-2' style={{borderBottom:'1px solid #d9d9d9', borderRadius:'0'}}>
      <NavItem>
        <NavLink  style={{
              backgroundColor: 'none',
              color: 'black',
              borderBottom: activeTab === '1' ? '2px solid orange' : 'none'
            }}
             active={activeTab === '1'} onClick={() => myCall('1')} className={activeTab !== '1' ? 'inactive-tab' : ''}>
          <span className='fw-bold'>Commission and Payouts</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
         style={{
            backgroundColor: 'none',
            color: 'black',
            borderBottom: activeTab === '2' ? '2px solid orange' : 'none'
          }}
           active={activeTab === '2'} onClick={() => myCall('2')} className={activeTab !== '2' ? 'inactive-tab' : ''}>
          <span className='fw-bold'>Payment Options</span> 
        </NavLink>
      </NavItem>
      </Nav>
    </div>
  )
}

export default TopTab
